angular.module('impactx.address').controller('UserAddressListController', [
    'selectedListItems',
    UserAddressListCtrl
]);

function UserAddressListCtrl(selectedListItems) {

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditProfile'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/address/templates/useraddresslist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/address/listuser',
        ctrl: this,
        id: "useraddresslist",
        mainAction: {id: "new", link: "#/useraddressdetail/0", icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "useraddressdetail/" + selectedListItems.getFirstSelectedId();
    }
}